export default {
  // Navigation
  nav: {
    home: 'الرئيسية',
    corporate: 'المؤسسة',
    collections: 'المجموعات',
    certificates: 'الشهادات',
    contact: 'اتصل بنا',
    hr: 'الموارد البشرية',
    sales: 'المبيعات',
    history: 'التاريخ',
    visionMission: 'الرؤية والرسالة',
    productionProcess: 'عملية الإنتاج',
    ourCertificates: 'شهاداتنا',
    regions: 'مناطقنا',
    eCatalog: 'الكتالوج الإلكتروني',
    dayMode: 'نهار',
    nightMode: 'ليل',
    blogNews: 'المدونة والأخبار',
    documents: 'وثائقنا',
    search: 'بحث...',
  },

  // Corporate submenu flat keys (used by Navigation component)
  'corporate.history': 'التاريخ',
  'corporate.visionMission': 'الرؤية والرسالة',
  'corporate.regions': 'مناطقنا',
  'corporate.certificates': 'شهاداتنا',
  'corporate.eCatalog': 'الكتالوج الإلكتروني',
  'corporate.productionProcess': 'عملية الإنتاج',
  'corporate.wholesaleCarpet': 'إنتاج السجاد بالجملة',
  'corporate.blogNews': 'المدونة والأخبار',
  'corporate.gaziantepCarpet': 'غازي عنتاب كاربت',

  // TopBanner
  topBanner: {
    quality: '✓ ضمان الجودة',
    production: '✓ إنتاج بمعايير عالمية',
    design: '✓ تصاميم عصرية',
    experience: '✓ 30 عاماً من الخبرة',
    certified: '✓ شهادة ISO 9001',
    qualityAssurance: '✓ ضمان الجودة',
    worldClassProduction: '✓ إنتاج بمعايير عالمية',
    modernDesigns: '✓ تصاميم عصرية',
    yearsExperience: '✓ 30 عاماً من الخبرة',
    isoCertified: '✓ شهادة ISO 9001',
  },

  // CollectionsGrid
  collectionsGrid: {
    title: '10 فئات خاصة',
    subtitle: 'مجموعاتنا',
    viewAll: 'عرض الكل',
    wholesaleCarpet: 'سجاد بالجملة',
    wholesaleBadge: 'سجاد بالجملة',
    products: 'منتجات',
    page: 'صفحة',
    notFound: 'لم يتم العثور على منتج',
    notFoundDesc: 'لا توجد منتجات في هذه الفئة بعد.',
    showAll: 'عرض جميع المنتجات',
    exploreAll: 'اكتشف جميع المجموعات',
    categories: {
      all: 'الكل',
      modern: 'سجاد عصري',
      classic: 'سجاد كلاسيك',
      minimalist: 'سجاد مينيماليست',
      bohemian: 'سجاد بوهيمي',
      geometric: 'سجاد هندسي',
      natural: 'سجاد طبيعي',
      luxury: 'سجاد فاخر',
      vintage: 'سجاد عتيق',
      ethnic: 'سجاد عرقي',
      kids: 'سجاد أطفال',
    },
  },

  // Certificates
  certificates: {
    title: 'شهاداتنا',
    subtitle: 'شهاداتنا الدولية التي تثبت جودتنا وموثوقيتنا',
  },

  // FactoryGallery
  factoryGallery: {
    title: 'منشأتنا الإنتاجية',
    subtitle: 'لحظات من مصنعنا حيث تلتقي التكنولوجيا الحديثة بالأيدي الماهرة',
  },

  // CustomerGallery
  customerGallery: {
    title: 'مساحات ملهمة',
    subtitle: 'تركيبات السجاد لدينا',
    description: 'اكتشف أجواء الفريدة التي تصنعها سجادنا في مساحات مختلفة',
    newCollection: 'مجموعة جديدة',
    catalogButton: 'كتالوج 2026',
    catalogDesc: 'اكتشف مجموعتنا الجديدة • 10 صفحات',
  },

  // SocialResponsibility
  socialResponsibility: {
    title: 'المسؤولية الاجتماعية',
    subtitle: 'الخطوات التي نتخذها من أجل مستقبل مستدام',
    goToCollections: 'انتقل إلى المجموعات',
    slide1Title: 'الإنتاج من أجل مستقبل أخضر',
    slide1Desc: 'نقلل من بصمتنا الكربونية من خلال عمليات إنتاج صديقة للبيئة وننتج سجاداً من مواد خام مستدامة.',
    slide2Title: 'نضيف قيمة للمجتمع',
    slide2Desc: 'نتنفيذ مشاريع المسؤولية الاجتماعية في طيف واسع من التعليم إلى الصحة ومن الثقافة إلى الفنون.',
    slide3Title: 'مواد خام مستدامة',
    slide3Desc: 'نستخدم خيوطاً معاد تدويرها وألياف عضوية، ونكون رواداً في الحفاظ على الموارد الطبيعية.',
  },

  // BlogSection
  blogSection: {
    title: 'المدونة والأخبار',
    subtitle: 'الأخبار الحالية من عالم النسيج والتطورات في قطاعنا',
    readMore: 'اقرأ المزيد',
    allPosts: 'جميع مقالات المدونة',
  },

  // GlobalImpact
  globalImpact: {
    title: 'خدمة في جميع أنحاء العالم',
    subtitle: 'التأثير المؤسسي العالمي',
    stats: {
      exportCountry: 'دولة التصدير',
      annualShipment: 'شحنة سنوية',
      continentReach: 'الوصول إلى القارة',
      carpetExport: 'تصدير السجاد بالمتر المربع',
    },
    countries: {
      usa: 'الولايات المتحدة الأمريكية',
      canada: 'كندا',
      mexico: 'المكسيك',
      brazil: 'البرازيل',
      argentina: 'الأرجنتين',
      uk: 'المملكة المتحدة',
      germany: 'ألمانيا',
      france: 'فرنسا',
      italy: 'إيطاليا',
      spain: 'إسبانيا',
      netherlands: 'هولندا',
      belgium: 'بلجيكا',
      switzerland: 'سويسرا',
      austria: 'النمسا',
      poland: 'بولندا',
      sweden: 'السويد',
      norway: 'النرويج',
      denmark: 'الدنمارك',
      russia: 'روسيا',
      turkey: 'تركيا',
      uae: 'الإمارات العربية المتحدة',
      saudiArabia: 'المملكة العربية السعودية',
      qatar: 'قطر',
      kuwait: 'الكويت',
      egypt: 'مصر',
      morocco: 'المغرب',
      southAfrica: 'جنوب أفريقيا',
      china: 'الصين',
      japan: 'اليابان',
      southKorea: 'كوريا الجنوبية',
      india: 'الهند',
      singapore: 'سنغافورة',
      malaysia: 'ماليزيا',
      thailand: 'تايلاند',
      australia: 'أستراليا',
      newZealand: 'نيوزيلندا',
    },
    description: 'من غازي عنتاب إلى العالم، نقدم منتجات عالية الجودة إلى أكثر من 50 دولة',
  },

  // HeroSlider
  heroSlider: {
    exploreCollections: 'استكشف المجموعات',
    discoverCollection: 'اكتشف المجموعة',
    slide0Title: 'سجاد Snekmax',
    slide0Desc: 'حيث تلتقي الجودة بالأناقة',
    slide1Title: 'سجاد Snekmax',
    slide1Desc: 'حيث تلتقي الجودة بالأناقة',
    slide2Title: 'مجموعاتنا',
    slide2Desc: 'تصاميم فريدة تجمع بين الرقي والفخامة',
    slide3Title: 'عملية الإنتاج لدينا',
    slide3Desc: 'إنتاج تلتقي فيه الجودة والكمال في كل خطوة',
    slide4Title: 'مجموعة Bella',
    slide4Desc: 'تصاميم فريدة تجمع بين الرقي والفخامة',
    slide5Title: 'مجموعة Sensitive',
    slide5Desc: 'إنتاج خاص للمسات الرقيقة',
    slide6Title: 'مجموعة Craft',
    slide6Desc: 'التفسير الحديث للحرف اليدوية',
    slide7Title: 'المجموعات الفاخرة',
    slide7Desc: 'سجاد حصري بإنتاج محدود',
    slide8Title: 'مجموعة Olympus',
    slide8Desc: 'سجادة الآلهة في منزلك',
    slide9Title: 'مجموعة Pashmina',
    slide9Desc: 'راحة بنعومة الحرير',
  },

  // DealerBanner
  dealerBanner: {
    title: 'انضم إلى شبكة الوكلاء لدينا',
    subtitle: 'شبكة وكلاء السجاد الأكثر شهرة في تركيا',
    subtitle2: 'شبكة وكلاء السجاد',
    description: 'نمّ أعمالك مع مجموعاتنا المميزة. استفد من أسعار الوكلاء الحصرية ودعم التسويق والخدمات المتميزة.',
    cardSubtitle: 'سجّل الدخول أو أنشئ حساباً الآن',
    stats: {
      activeDealers: 'وكيل نشط',
      provinceCoverage: 'تغطية المحافظات',
      profitMargin: 'هامش الربح',
    },
    activeDealers: 'وكيل نشط',
    cityReach: 'تغطية المدن',
    profitMargin: 'هامش الربح',
    dealerPortal: 'بوابة الوكلاء',
    dealerLogin: 'تسجيل دخول الوكيل',
    createAccount: 'إنشاء حساب وكيل',
    secureLogin: 'تسجيل دخول آمن',
    support247: 'دعم 24/7',
  },

  // DealerFloat
  dealerFloat: {
    intro: 'مقدمة',
    dealerLogin: 'تسجيل دخول الوكيل',
    like: 'إعجاب',
    dealerPortal: 'بوابة الوكلاء',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور',
    login: 'تسجيل الدخول',
    companyName: 'اسم الشركة',
    authorizedName: 'الاسم المعتمد',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    location: 'الموقع',
    message: 'الرسالة',
    submit: 'إرسال',
    close: 'إغلاق',
    introTitle: 'مرحباً بكم في عالم السجاد',
    introDescription: 'اكتشف مجموعاتنا الفريدة من السجاد وكن جزءاً من شبكة الوكلاء لدينا',
    viewCollections: 'عرض المجموعات',
    becomeDealer: 'كن وكيلاً',
    dealerLoginBtn: 'تسجيل دخول الوكيل',
  },

  // ContactFloat
  contactFloat: {
    whatsapp: 'واتساب',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    location: 'الموقع',
    message: 'الرسالة',
    dealerLogin: 'تسجيل دخول الوكيل',
    sendMessage: 'إرسال رسالة',
    name: 'الاسم',
    emailAddress: 'عنوان البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    subject: 'الموضوع',
    yourMessage: 'رسالتك',
    send: 'إرسال',
    close: 'إغلاق',
  },

  // Footer
  footer: {
    about: 'حول',
    quickLinks: 'روابط سريعة',
    contact: 'اتصل بنا',
    followUs: 'تابعنا',
    allRightsReserved: 'جميع الحقوق محفوظة',
    privacyPolicy: 'سياسة الخصوصية',
    termsOfService: 'شروط الخدمة',
    seoLinks: {
      title: 'فئات السجاد الشائعة',
      wholesaleCarpet: 'بيع السجاد بالجملة',
      modernCarpet: 'سجاد عصري',
      luxuryCarpet: 'سجاد فاخر',
      carpetExport: 'تصدير السجاد',
      carpetProduction: 'إنتاج السجاد',
      handwovenCarpet: 'سجاد منسوج يدويًا',
      carpetDealer: 'وكالة السجاد',
      turkishCarpet: 'سجاد تركي',
      carpetFair: 'معارض السجاد',
      qualityCarpet: 'سجاد عالي الجودة',
      hotelCarpet: 'سجاد الفنادق',
      vintageCarpet: 'سجاد عتيق',
      carpetWholesale: 'تجارة السجاد بالجملة',
      ecoCarpet: 'سجاد صديق للبيئة',
      carpetFactory: 'مصنع السجاد',
    },
    companyName: '2026 مصنع السجاد بالجملة.',
  },

  // Common
  common: {
    loading: 'جاري التحميل...',
    error: 'خطأ',
    success: 'نجاح',
    close: 'إغلاق',
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    view: 'عرض',
    search: 'بحث',
    filter: 'تصفية',
    sort: 'ترتيب',
    next: 'التالي',
    previous: 'السابق',
    submit: 'إرسال',
    reset: 'إعادة تعيين',
    confirm: 'تأكيد',
    back: 'رجوع',
  },

  // Blog Page
  'blog.heroLabel': '10 مقالات جديدة',
  'blog.heroTitle': 'أخبار صناعة السجاد',
  'blog.heroSubtitle':
    '<strong>بيع السجاد بالجملة</strong>، مغامرات المعارض الدولية، إنجازات التصدير واتجاهات إنتاج السجاد — أحدث الأخبار',
  'blog.breadcrumbHome': 'الرئيسية',
  'blog.breadcrumbBlog': 'المدونة والأخبار',
  'blog.categoryAll': 'الكل',
  'blog.categoryFair': 'معرض',
  'blog.categoryExport': 'تصدير',
  'blog.categoryCollection': 'مجموعة',
  'blog.categorySustainability': 'الاستدامة',
  'blog.categoryCampaign': 'حملة',
  'blog.categoryProduction': 'إنتاج',
  'blog.categoryProject': 'مشروع',
  'blog.categoryGuide': 'دليل',
  'blog.seoIntro':
    'في صفحة مدونتنا التي تغطي نبض صناعة <strong>بيع السجاد بالجملة</strong> و<strong>تصدير السجاد</strong>، يمكنك العثور على أحدث الأخبار حول <strong>معارض السجاد</strong> الدولية، وإطلاق المجموعات الجديدة، وحملات البيع بالجملة وعمليات إنتاج السجاد. مع أكثر من 30 عامًا من الخبرة في صناعة السجاد، نقدم محتوى قيمًا لمشتري السجاد بالجملة ووكلائنا.',
  'blog.readMore': 'اقرأ المزيد',
  'blog.readTime': 'قراءة',
  'blog.noPostsInCategory': 'لا توجد أخبار في هذه الفئة بعد.',
  'blog.share': 'مشاركة:',
  'blog.seoCard1Title': 'معارض السجاد الدولية',
  'blog.seoCard1Desc':
    'نوسع شبكة مبيعات السجاد بالجملة من خلال المشاركة في أرقى <strong>معارض السجاد</strong> في العالم مثل ميلانو وباريس وهاي بوينت.',
  'blog.seoCard2Title': 'تصدير السجاد',
  'blog.seoCard2Desc':
    'نمثل قوة صناعة السجاد التركية في السوق العالمية من خلال <strong>تصدير السجاد بالجملة</strong> إلى أكثر من 25 دولة.',
  'blog.seoCard3Title': 'الجودة والشهادات',
  'blog.seoCard3Desc':
    'في منشآتنا الإنتاجية المعتمدة بشهادة ISO، ننتج السجاد بأعلى معايير الجودة <strong>لبيع السجاد بالجملة</strong>.',
  'blog.faqTitle': 'الأسئلة الشائعة',
  'blog.faq1Q': 'ما هو الحد الأدنى لكمية الطلب لشراء السجاد بالجملة؟',
  'blog.faq1A':
    'يختلف الحد الأدنى لكمية الطلب لشراء السجاد بالجملة حسب المجموعة، لكننا نقدم عادةً مزايا أسعار الجملة للطلبات التي تبلغ 100 متر مربع وأكثر. يرجى الاتصال بفريق المبيعات لدينا للحصول على معلومات مفصلة.',
  'blog.faq2Q': 'إلى أي دول تصدرون السجاد؟',
  'blog.faq2A':
    'يصل تصدير السجاد لدينا إلى أكثر من 25 دولة. نقوم بنشاط ببيع السجاد بالجملة في الأسواق الأوروبية والشرق أوسطية والأمريكية والآسيوية. إيطاليا وألمانيا وفرنسا والولايات المتحدة والإمارات هي أسواق التصدير الرئيسية لدينا.',
  'blog.faq3Q': 'ما هي شروط الدفع لشراء السجاد بالجملة؟',
  'blog.faq3A':
    'نقدم خيارات دفع مرنة لمشتريات السجاد بالجملة. خصم إضافي للدفع النقدي، وخيارات أقساط 30-60-90 يومًا، واعتماد مستندية للطلبات التصديرية.',
  'blog.faq4Q': 'كيف يمكنني زيارة معرض السجاد؟',
  'blog.faq4A':
    'نشارك بانتظام في معرض السجاد الدولية. يمكنك زيارة جناحنا في معرض ميلانو وباريس وهاي بوينت أو طلب موعد خاص. تابع مدونتنا للاطلاع على جدول المعارض.',

  // Blog Posts
  'blog.post1.title': 'أخذنا مكاننا في Milano Carpet Expo 2026 — عصر جديد في مبيعات السجاد بالجملة',
  'blog.post1.excerpt':
    'جذبت شركتنا الانتباه بفرص البيع بالجملة والتصدير في أرقى معرض سجاد أوروبي Milano Carpet Expo 2026.',
  'blog.post1.date': '18 يناير 2026',
  'blog.post1.readTime': '6 دقائق',
  'blog.post2.title': 'High Point Market 2026: عاصفة السجاد التركي في السوق الأمريكية',
  'blog.post2.excerpt':
    'حظيت مجموعات السجاد بالجملة لدينا باهتمام كبير في أكبر معرض أثاث وسجاد في العالم High Point.',
  'blog.post2.date': '12 يناير 2026',
  'blog.post2.readTime': '7 دقائق',
  'blog.post3.title': 'Paris Deco Off 2026: تصاميم السجاد الفاخرة لدينا سحرت أوروبا',
  'blog.post3.excerpt':
    'التقينا بالمشترين بالجملة بمجموعات السجاد الحديثة والكلاسيكية في معرض التصميم المرموق في باريس.',
  'blog.post3.date': '5 يناير 2026',
  'blog.post3.readTime': '5 دقائق',
  'blog.post4.title': '35 طنًا من تصدير السجاد في 2025 — حطمنا الرقم القياسي!',
  'blog.post4.excerpt':
    'نجاح كبير في مبيعات السجاد بالجملة: وصلنا إلى أعلى رقم في تاريخ شركتنا بتصدير 35 طنًا من السجاد إلى 25 دولة.',
  'blog.post4.date': '28 ديسمبر 2025',
  'blog.post4.readTime': '5 دقائق',
  'blog.post5.title': 'تم إطلاق مجموعة سجاد ربيع-صيف 2026 — اتجاهات جديدة',
  'blog.post5.excerpt':
    'تتميز مجموعتنا ربيع-صيف 2026 المعدة لمبيعات السجاد بالجملة بلوحات ألوان مستوحاة من الطبيعة وأنماط حديثة.',
  'blog.post5.date': '20 ديسمبر 2025',
  'blog.post5.readTime': '6 دقائق',
  'blog.post6.title': 'إنتاج السجاد المستدام: نهجنا الصديق للبيئة',
  'blog.post6.excerpt':
    'نساهم في مستقبل مستدام بمواد صديقة للبيئة وعمليات موفرة للطاقة في إنتاج السجاد بالجملة.',
  'blog.post6.date': '15 ديسمبر 2025',
  'blog.post6.readTime': '8 دقائق',
  'blog.post7.title': 'مزايا أسعار خاصة لمشتري السجاد بالجملة في 2026',
  'blog.post7.excerpt':
    'بدأت حملة مبيعات السجاد بالجملة الخاصة لعام 2026. خصمات خاصة لوكلائنا ومشترينا بالجملة.',
  'blog.post7.date': '10 ديسمبر 2025',
  'blog.post7.readTime': '4 دقائق',
  'blog.post8.title': 'تقنيات جديدة وفن تقليدي في إنتاج السجاد المنسوج يدويًا',
  'blog.post8.excerpt':
    'نجمع بين فن نسج السجاد التقليدي والتقنيات الحديثة. مجموعات السجاد المنسوج يدويًا تحظى باهتمام كبير.',
  'blog.post8.date': '5 ديسمبر 2025',
  'blog.post8.readTime': '7 دقائق',
  'blog.post9.title': 'حلول سجاد خاصة لمشاريع الفنادق والمطاعم',
  'blog.post9.excerpt':
    'نقدم حلولًا خاصة للفنادق والمطاعم والمشاريع التجارية في مبيعات السجاد بالجملة.',
  'blog.post9.date': '28 نوفمبر 2025',
  'blog.post9.readTime': '6 دقائق',
  'blog.post10.title': 'دليل العناية بالسجاد: نصائح للاستخدام طويل الأمد',
  'blog.post10.excerpt': 'نشارك دليل العناية بالسجاد لرضا العملاء بعد البيع بالجملة.',
  'blog.post10.date': '20 نوفمبر 2025',
  'blog.post10.readTime': '5 دقائق',

  // Quick Menu
  quickMenu: {
    title: 'القائمة السريعة',
    subtitle: 'MONS HALI سجاد',
    language: 'اللغة',
    collections: 'المجموعات',
    dealerLogin: 'تسجيل دخول الوكيل',
    dealerLoginDesc: 'الوصول إلى لوحة الوكيل',
    contact: 'اتصل بنا',
    kvkk: 'KVKK والمستندات',
    whatsapp: 'واتساب',
    whatsappDesc: 'إرسال رسالة',
    call: 'اتصل',
    callDesc: 'اتصل الآن',
  },

  // Wholesale Carpet Production Page
  'wholesale.heroLabel': 'إنتاج السجاد بالجملة والتجارة العالمية',
  'wholesale.heroTitle': 'إنتاج السجاد بالجملة وتجارة السجاد العالمية',
  'wholesale.heroSubtitle':
    'بوصفنا من كبار مصنّعي السجاد بالجملة من غازي عنتاب إلى العالم، نصدّر سجاداً عالي الجودة إلى أكثر من 50 دولة. نحن شريككم الموثوق في السوق العالمية بوصفنا تاجر جملة للسجاد.',
  'wholesale.heroAlt': 'مصنع إنتاج السجاد بالجملة',
  'wholesale.ctaContact': 'تواصل معنا',
  'wholesale.ctaCollections': 'استعرض المجموعات',

  'wholesale.stat1': 'دول التصدير',
  'wholesale.stat2': 'م² إنتاج سنوي',
  'wholesale.stat3': 'سنوات من الخبرة',
  'wholesale.stat4': 'موظف متخصص',

  'wholesale.introLabel': 'من نحن',
  'wholesale.introTitle': 'تاجر الجملة الرائد للسجاد في تركيا',
  'wholesale.introP1':
    'بخبرة تمتد لأكثر من 30 عاماً، تُعدّ MONS HALI من أعرق مصنّعي السجاد بالجملة في تركيا. في منشآتنا الإنتاجية الحديثة في غازي عنتاب، ننتج آلاف الأمتار المربعة من السجاد يومياً، ونوفّر إمدادات متواصلة لتجار الجملة والموزعين في جميع أنحاء العالم.',
  'wholesale.introP2':
    'تشمل مجموعتنا الواسعة في مبيعات السجاد بالجملة: السجاد الآلي، والسجاد اليدوي، والتصاميم العصرية، والمجموعات الكلاسيكية. نبتكر حلولاً مخصصة لكل عميل ونوفّر مرونة في الحد الأدنى لكميات الطلب.',
  'wholesale.introP3':
    'بفضل عمليات الإنتاج المعتمدة بشهادة ISO 9001، واستخدام المواد الخام المطابقة لمعايير OEKO-TEX، وآليات مراقبة الجودة الصارمة، نبرز بوصفنا علامة تجارية موثوقة في تصدير السجاد.',
  'wholesale.isoCertified': 'إنتاج معتمد',

  'wholesale.processLabel': 'عملية الإنتاج',
  'wholesale.processTitle': 'عمليات إنتاج السجاد بالجملة',
  'wholesale.processSubtitle':
    'الجودة والدقة في كل مرحلة من المواد الخام إلى المنتج النهائي. 5 عمليات رئيسية في إنتاج السجاد بالجملة.',
  'wholesale.processBannerTitle': 'تحكم شامل في الإنتاج',
  'wholesale.processBannerDesc':
    'تُشرف فرقتنا المتخصصة على كل مرحلة من اختيار المواد الخام حتى التعبئة.',
  'wholesale.process1Title': 'اختيار المواد الخام',
  'wholesale.process1Desc':
    'يتم اختيار الخيوط عالية الجودة والألياف الطبيعية بعناية وإخضاعها لاختبارات الجودة.',
  'wholesale.process2Title': 'النسيج والإنتاج',
  'wholesale.process2Desc':
    'تُنتج السجاد بمزيج من الآلات المتطورة والأيدي الماهرة.',
  'wholesale.process3Title': 'الصباغة والتلوين',
  'wholesale.process3Desc':
    'تُحقَّق ألوان زاهية ودائمة باستخدام أصباغ صديقة للبيئة.',
  'wholesale.process4Title': 'مراقبة الجودة',
  'wholesale.process4Desc':
    'يخضع كل سجادة لاختبارات جودة متعددة المراحل ويتم التحقق من المعايير.',
  'wholesale.process5Title': 'التعبئة والشحن',
  'wholesale.process5Desc':
    'تُعبَّأ المنتجات بأمان في تغليف خاص وتُشحن إلى جميع أنحاء العالم.',

  'wholesale.typesLabel': 'أنواع السجاد',
  'wholesale.typesTitle': 'الفروق بين السجاد الآلي والسجاد اليدوي',
  'wholesale.typesSubtitle':
    'فئتان رئيسيتان للإنتاج في مبيعات السجاد بالجملة: السجاد الآلي الحديث والسجاد المنسوج يدوياً التقليدي.',
  'wholesale.machineCarpetTitle': 'السجاد الآلي',
  'wholesale.machineCarpetDesc':
    'يُعدّ السجاد الآلي المنتج بآلات النسيج عالية التقنية الفئة الأكثر طلباً في مبيعات السجاد بالجملة. بمقاسات قياسية وخيارات ألوان واسعة وأسعار تنافسية، فهو مثالي للطلبات الكبيرة الحجم. تتيح الطاقة الإنتاجية اليومية بآلاف الأمتار المربعة التسليم السريع.',
  'wholesale.handCarpetTitle': 'السجاد اليدوي',
  'wholesale.handCarpetDesc':
    'يتميز السجاد المنسوج يدوياً من قِبل الحرفيين المهرة في القطاع الفاخر بأنماطه وملمسه الفريدين. كل قطعة منه تحفة فنية؛ يُفضَّل السجاد اليدوي للفنادق والمتاجر الراقية والمشاريع الخاصة. تتوفر خيارات التصميم والمقاسات المخصصة لطلبات السجاد اليدوي بالجملة.',
  'wholesale.tag.fast': 'إنتاج سريع',
  'wholesale.tag.uniform': 'جودة موحدة',
  'wholesale.tag.affordable': 'سعر تنافسي',
  'wholesale.tag.unique': 'تصميم فريد',
  'wholesale.tag.artisan': 'صنع يدوي',
  'wholesale.tag.premium': 'قطاع فاخر',

  'wholesale.qualityLabel': 'مراقبة الجودة',
  'wholesale.qualityTitle': 'مراقبة الجودة في إنتاج السجاد',
  'wholesale.qualitySubtitle':
    'تضمن عمليات مراقبة الجودة متعددة المراحل في إنتاج السجاد بالجملة لدينا أن كل منتج يستوفي المعايير الدولية.',
  'wholesale.quality1Title': 'تحليل المواد الخام',
  'wholesale.quality1Desc':
    'تخضع جميع الخيوط والألياف المستخدمة في الإنتاج لاختبارات فيزيائية وكيميائية في مختبرات معتمدة. تُطبَّق المعايير التي تستلزم شهادة OEKO-TEX بدقة.',
  'wholesale.quality2Title': 'التحكم أثناء الإنتاج',
  'wholesale.quality2Desc':
    'تُجرى عمليات تحكم فورية في الجودة في مراحل النسيج والصباغة والتشطيب. يُراقَب باستمرار توحيد الألوان ودقة النمط وجودة السطح.',
  'wholesale.quality3Title': 'فحص المنتج النهائي',
  'wholesale.quality3Desc':
    'يخضع كل سجادة مكتملة لفحص نهائي شامل للتحقق من دقة الأبعاد وعيوب السطح والمتانة. لا تُشحن المنتجات التي لا تستوفي المعايير.',
  'wholesale.quality4Title': 'الاعتماد الدولي',
  'wholesale.quality4Desc':
    'بفضل نظام إدارة الجودة ISO 9001 ومعيار OEKO-TEX Standard 100 وشهادات CE، نوفّر ضمانات دولية في تصدير السجاد بالجملة.',
  'wholesale.qualityBannerTitle': 'سياسة الصفر عيوب',
  'wholesale.qualityBannerDesc':
    'ضمان جودة 100% في كل طلب سجاد بالجملة. نصدّر بثقة مدعومة بشهادات الامتثال الدولية.',

  'wholesale.exportLabel': 'اللوجستيات والتصدير',
  'wholesale.exportTitle': 'عملية اللوجستيات والتصدير',
  'wholesale.exportSubtitle':
    'بفضل شبكة تصدير السجاد الممتدة من غازي عنتاب إلى العالم، نوفّر التسليم الآمن وفي الوقت المحدد إلى أكثر من 50 دولة.',
  'wholesale.exportMapTitle': 'شبكة تصدير السجاد العالمية',
  'wholesale.exportMapDesc':
    'تصدير السجاد بالجملة إلى أكثر من 50 دولة في أوروبا والشرق الأوسط وآسيا وأفريقيا',
  'wholesale.region.europe': 'أوروبا',
  'wholesale.region.middleEast': 'الشرق الأوسط',
  'wholesale.region.asia': 'آسيا',
  'wholesale.region.africa': 'أفريقيا',
  'wholesale.logisticsTitle': 'لوجستيات آمنة وتسليم سريع',
  'wholesale.logisticsDesc':
    'تصل طلبات السجاد بالجملة بأمان بفضل التغليف الخاص والشحن المؤمَّن وخيارات التوصيل من الباب إلى الباب.',

  'wholesale.turkeyLabel': 'قوة تركيا',
  'wholesale.turkeyTitle': 'قوة تركيا في إنتاج السجاد',
  'wholesale.turkeyP1':
    'تُعدّ تركيا، بوصفها رائدة في تصدير السجاد عالمياً، قوة محورية في السوق الدولية. تُسهم مراكز إنتاج السجاد في تركيا، خاصة غازي عنتاب، في الاقتصاد العالمي بحجم صادرات سنوي يبلغ مليارات الدولارات.',
  'wholesale.turkeyP2':
    'تبتكر صناعة السجاد التركية منتجات فريدة بمزج الحرف التقليدية مع تقنيات الإنتاج الحديثة. يواصل السعر التنافسي والجودة العالية والتشكيلة الواسعة من التصاميم في تركيا في إنتاج السجاد بالجملة كونها الخيار الأول لتجار الجملة العالميين.',
  'wholesale.turkeyP3':
    'بوصفنا أحد الممثلين الرائدين لهذه الصناعة القوية، نواصل بعزم مهمتنا في نقل فن السجاد التركي إلى العالم. نعمل كل يوم لنكون علامة تركيا التجارية في تصدير السجاد.',
  'wholesale.turkeyRank': 'في تصدير السجاد العالمي',
  'wholesale.turkeyFact1': 'حصة تصدير السجاد العالمي',
  'wholesale.turkeyFact2': 'قيمة التصدير السنوية',
  'wholesale.turkeyFact3': 'دولة مستوردة',

  'wholesale.distLabel': 'التوزيع',
  'wholesale.distTitle': 'مبيعات السجاد العالمية ونظام التوزيع',
  'wholesale.distSubtitle':
    'تُشكّل الشراكات التجارية القوية التي أقمناها مع تجار الجملة والموزعين في جميع أنحاء العالم أساس مبيعات السجاد العالمية لدينا.',
  'wholesale.dist1Title': 'شبكة الوكلاء المحليين',
  'wholesale.dist1Desc':
    'نبني شبكة مبيعات محلية قوية مع أكثر من 170 وكيلاً نشطاً في جميع أنحاء تركيا. نقدم للوكلاء تسعيراً حصرياً ودعماً تسويقياً وبرامج تدريبية.',
  'wholesale.dist2Title': 'الموزعين الدوليون',
  'wholesale.dist2Desc':
    'نُجري مبيعات السجاد العالمية من خلال موزعينا المعتمدين في أكثر من 50 دولة. نقدم شروط تجارية مخصصة وحلولاً لوجستية لكل منطقة.',
  'wholesale.dist3Title': 'المبيعات المؤسسية والمشاريع',
  'wholesale.dist3Desc':
    'ننتج حلول سجاد بالجملة خاصة للفنادق ومراكز التسوق والمكاتب والمشاريع العامة. نضمن أسعاراً تنافسية وتسليماً سريعاً للمشاريع الكبيرة الحجم.',

  'wholesale.faqLabel': 'الأسئلة الشائعة',
  'wholesale.faqTitle': 'الأسئلة الشائعة',
  'wholesale.faq1Q': 'ما هو الحد الأدنى لكمية الطلب في إنتاج السجاد بالجملة؟',
  'wholesale.faq1A':
    'يتفاوت الحد الأدنى لطلبات السجاد بالجملة حسب المجموعة ونوع المنتج. بالنسبة لطلبات السجاد الآلي، تُقدَّم مزايا أسعار الجملة عادةً للطلبات التي تبلغ 100 م² وأكثر. يرجى التواصل مع فريق المبيعات للحصول على معلومات تفصيلية.',
  'wholesale.faq2Q': 'إلى أي دول تُسلّمون عند تصدير السجاد؟',
  'wholesale.faq2A':
    'نصدّر السجاد إلى أكثر من 50 دولة تشمل أوروبا والشرق الأوسط وآسيا وأفريقيا. تُعدّ ألمانيا وفرنسا والإمارات والمملكة العربية السعودية والصين واليابان من أبرز أسواق التصدير لدينا. تواصل معنا للاطلاع على شروط التسليم الخاصة ببلدك.',
  'wholesale.faq3Q': 'ما الفروق الجوهرية بين السجاد الآلي والسجاد اليدوي؟',
  'wholesale.faq3A':
    'يُنتج السجاد الآلي بآلات نسيج عالية السرعة؛ يوفر جودة موحدة وتسليماً سريعاً وأسعاراً تنافسية. أما السجاد اليدوي فيُنسج يدوياً من قِبل الحرفيين المهرة؛ كل قطعة فريدة وتستغرق وقتاً أطول في الإنتاج وتنتمي إلى القطاع الفاخر. نوفّر مخزوناً واسعاً من كلتا الفئتين في مبيعات السجاد بالجملة.',
  'wholesale.faq4Q': 'ما هي شروط الدفع لطلبات السجاد بالجملة؟',
  'wholesale.faq4A':
    'نقدم خيارات دفع مرنة لمشتريات السجاد بالجملة: خصم إضافي للدفع النقدي، وخيارات دفع مؤجل 30-60-90 يوماً، واعتماد مستندي لطلبات التصدير. تُمنح حدود ائتمانية خاصة لشركائنا التجاريين طويلي الأمد.',
  'wholesale.faq5Q': 'هل يمكنني تقديم طلب سجاد بالجملة بتصميم مخصص؟',
  'wholesale.faq5A':
    'نعم، يمكننا إنتاج سجاد بالجملة بتصاميم وألوان ومقاسات مخصصة لعملائنا المؤسسيين والمشترين بكميات كبيرة. تُطبَّق حدود دنيا للطلب على السجاد المطبوع بالشعار والتركيبات المخصصة من الأنماط والألوان. يرجى التواصل مع فريق المبيعات لمشاركة تفاصيل مشروعك.',

  'wholesale.ctaTitle': 'تواصل معنا لطلبات السجاد بالجملة',
  'wholesale.ctaDesc':
    'بوصفنا تاجر جملة للسجاد، نقدم حلول إمداد موثوقة في جميع أنحاء العالم. تواصل معنا الآن لمبيعات السجاد بالجملة والتصدير والتوزيع.',

  // Gaziantep Carpet Page
  'gaziantepCarpet.heroLabel': 'مصنع سجاد غازي عنتاب والتصدير العالمي',
  'gaziantepCarpet.heroTitle': 'Gaziantep Carpet — قلب إنتاج السجاد في تركيا',
  'gaziantepCarpet.heroSubtitle':
    'بوصفنا من كبار مصنّعي السجاد بالجملة بين مصانع سجاد غازي عنتاب، نوصّل طلبات السجاد بالجملة إلى جميع أنحاء العالم بطاقة إنتاجية عالية وبنية لوجستية متينة. نصدّر إلى أكثر من 80 دولة بوصفنا تاجر جملة للسجاد.',
  'gaziantepCarpet.heroAlt': 'مصنع سجاد غازي عنتاب',
  'gaziantepCarpet.ctaContact': 'تواصل معنا',
  'gaziantepCarpet.ctaCollections': 'استعرض المجموعات',

  'gaziantepCarpet.stat1': 'مصانع سجاد في غازي عنتاب',
  'gaziantepCarpet.stat2': 'م² إنتاج سنوي',
  'gaziantepCarpet.stat3': 'دول التصدير',
  'gaziantepCarpet.stat4': 'سنوات من الخبرة',

  'gaziantepCarpet.introLabel': 'إنتاج السجاد بالجملة في غازي عنتاب',
  'gaziantepCarpet.introTitle': 'إنتاج السجاد بالجملة في غازي عنتاب وتاجر الجملة للسجاد',
  'gaziantepCarpet.introP1':
    'تُعدّ غازي عنتاب أحد أكبر مراكز إنتاج السجاد في تركيا والعالم. يعمل في المدينة أكثر من 500 مصنع سجاد، ويتجاوز الإنتاج السنوي 2 مليار متر مربع. تحتل MONS HALI مكانة رائدة في هذه المنظومة القوية بوصفها تاجر جملة للسجاد، وتوفّر إمدادات متواصلة وعالية الجودة للمشترين العالميين.',
  'gaziantepCarpet.introP2':
    'ينتج مصنع السجاد لدينا في غازي عنتاب السجاد الآلي والسجاد اليدوي وسجاد المقاسات المخصصة. تظل أسعار السجاد بالجملة تنافسية بفضل طاقتنا الإنتاجية العالية وشبكتنا اللوجستية الفعّالة. بوصفنا شركة مصنّعة للسجاد، نقدم حلولاً مخصصة لكل عميل.',
  'gaziantepCarpet.introP3':
    'بوصفنا مصنّعاً للسجاد بالجملة، نصدّر بانتظام إلى الأسواق الأوروبية والشرق أوسطية والآسيوية. تستوفي عمليات الإنتاج المعتمدة بشهادة ISO 9001 واستخدام المواد الخام المطابقة لمعايير OEKO-TEX معايير الجودة الدولية.',
  'gaziantepCarpet.badge1': 'مصنع سجاد غازي عنتاب',
  'gaziantepCarpet.badge2': 'مصنّع سجاد بالجملة',
  'gaziantepCarpet.badge3': 'معتمد ISO 9001',
  'gaziantepCarpet.isoCertified': 'إنتاج معتمد',

  'gaziantepCarpet.factoryBannerAlt': 'مصانع سجاد غازي عنتاب',
  'gaziantepCarpet.factoryBannerTitle': 'مصانع سجاد غازي عنتاب — مركز الإنتاج العالمي',
  'gaziantepCarpet.factoryBannerDesc':
    'تُنتج آلاف الأمتار المربعة من السجاد يومياً في منشآتنا الإنتاجية الحديثة في غازي عنتاب. نحن في خدمتكم بطاقة إنتاجية عالية وتسليم سريع وأسعار تنافسية للسجاد بالجملة.',

  'gaziantepCarpet.advLabel': 'لماذا تختارنا',
  'gaziantepCarpet.advTitle': 'مزايا مصنع السجاد لدينا في غازي عنتاب',
  'gaziantepCarpet.advSubtitle':
    'نتميز عن المنافسين بـ 6 مزايا رئيسية بوصفنا تاجر جملة ومصنّع للسجاد.',
  'gaziantepCarpet.adv1Title': 'طاقة إنتاجية عالية',
  'gaziantepCarpet.adv1Desc':
    'بطاقة إنتاجية يومية تبلغ 50,000 م² في مصنعنا بغازي عنتاب، نُنجز طلبات السجاد بالجملة الكبيرة في وقت قصير.',
  'gaziantepCarpet.adv2Title': 'بنية لوجستية متينة',
  'gaziantepCarpet.adv2Desc':
    'بفضل الموقع الاستراتيجي لغازي عنتاب وشبكتها اللوجستية المتطورة، نوفّر التسليم السريع والآمن إلى أوروبا والشرق الأوسط وآسيا.',
  'gaziantepCarpet.adv3Title': 'أسعار تنافسية للسجاد بالجملة',
  'gaziantepCarpet.adv3Desc':
    'نقدم أكثر أسعار السجاد بالجملة تنافسية في السوق بفضل كفاءتنا الإنتاجية العالية ومزايا المواد الخام.',
  'gaziantepCarpet.adv4Title': 'تشكيلة واسعة من التصاميم',
  'gaziantepCarpet.adv4Desc':
    'نلبّي متطلبات كل سوق بأكثر من 1000 خيار من الأنماط والألوان، بما فيها التصاميم الحديثة والكلاسيكية والعرقية والمخصصة.',
  'gaziantepCarpet.adv5Title': 'معايير الجودة الدولية',
  'gaziantepCarpet.adv5Desc':
    'نوفّر ضمانات دولية في تصدير السجاد بالجملة بشهاداتنا ISO 9001 وOEKO-TEX وCE.',
  'gaziantepCarpet.adv6Title': 'دعم العملاء على مدار الساعة',
  'gaziantepCarpet.adv6Desc':
    'نقدم خدمة على مدار الساعة لتتبع الطلبات والدعم الفني وإعداد وثائق التصدير في مشتريات السجاد بالجملة.',

  'gaziantepCarpet.prodLabel': 'فئات المنتجات',
  'gaziantepCarpet.prodTitle': 'السجاد الآلي والسجاد اليدوي وإنتاج المقاسات المخصصة',
  'gaziantepCarpet.prodSubtitle':
    'ثلاث فئات رئيسية تُنتج في مصنع السجاد لدينا في غازي عنتاب: سجاد آلي عالي الطاقة، وسجاد يدوي فاخر، وسجاد للمشاريع الخاصة.',
  'gaziantepCarpet.prod1Title': 'إنتاج السجاد الآلي',
  'gaziantepCarpet.prod1Desc':
    'يُعدّ السجاد الآلي المنتج بآلات نسيج متطورة الفئة الأكثر طلباً في مبيعات السجاد بالجملة. الطاقة الإنتاجية اليومية العالية والجودة الموحدة والأسعار التنافسية تجعله مثالياً للطلبات الكبيرة الحجم.',
  'gaziantepCarpet.prod2Title': 'إنتاج السجاد اليدوي',
  'gaziantepCarpet.prod2Desc':
    'يتميز السجاد المنسوج يدوياً من قِبل الحرفيين غازي عنتاب المهرة في القطاع الفاخر. يُفضَّل للفنادق والمتاجر الراقية والمشاريع الخاصة، ويُضفي قيمة على كل مكان بأنماطه وملمسه الفريدين.',
  'gaziantepCarpet.prod3Title': 'إنتاج سجاد بمقاسات مخصصة',
  'gaziantepCarpet.prod3Desc':
    'ننتج سجاداً بمقاسات وألوان وتركيبات أنماط مخصصة للعملاء المؤسسيين والمشاريع الكبيرة. نقدم حلول سجاد بالجملة خاصة للفنادق ومراكز التسوق والمكاتب والمشاريع العامة.',
  'gaziantepCarpet.tag.machine': 'سجاد آلي',
  'gaziantepCarpet.tag.bulk': 'طلب بالجملة',
  'gaziantepCarpet.tag.fast': 'تسليم سريع',
  'gaziantepCarpet.tag.handmade': 'منسوج يدوياً',
  'gaziantepCarpet.tag.premium': 'فاخر',
  'gaziantepCarpet.tag.unique': 'تصميم فريد',
  'gaziantepCarpet.tag.modern': 'تصميم حديث',
  'gaziantepCarpet.tag.custom': 'إنتاج مخصص',
  'gaziantepCarpet.tag.export': 'تصدير',

  'gaziantepCarpet.logisticsBannerAlt': 'لوجستيات وتصدير السجاد',
  'gaziantepCarpet.logisticsBannerTitle': 'التصدير واللوجستيات — من غازي عنتاب إلى العالم',
  'gaziantepCarpet.logisticsBannerDesc':
    'بفضل الموقع الاستراتيجي لغازي عنتاب وروابطها البرية والجوية المتطورة، نوصّل طلبات السجاد بالجملة إلى أوروبا والشرق الأوسط وآسيا بسرعة وأمان.',

  'gaziantepCarpet.exportLabel': 'التصدير العالمي',
  'gaziantepCarpet.exportTitle': 'بيع السجاد من تركيا إلى العالم',
  'gaziantepCarpet.exportSubtitle':
    'نصدّر السجاد بالجملة من مصنع السجاد لدينا في غازي عنتاب إلى أكثر من 80 دولة. نعمل مع شركاء تجاريين موثوقين في جميع القارات، وخاصة في أوروبا والشرق الأوسط.',
  'gaziantepCarpet.exportMapTitle': 'تصدير السجاد من غازي عنتاب إلى 80+ دولة',
  'gaziantepCarpet.exportMapDesc':
    'مبيعات السجاد بالجملة عبر شبكة موزعينا القوية في أوروبا والشرق الأوسط وآسيا وأفريقيا',
  'gaziantepCarpet.market1': 'السوق الأوروبية',
  'gaziantepCarpet.market2': 'سوق الشرق الأوسط',
  'gaziantepCarpet.market3': 'السوق الآسيوية',
  'gaziantepCarpet.market4': 'السوق الأفريقية',

  'gaziantepCarpet.whyLabel': 'لماذا غازي عنتاب',
  'gaziantepCarpet.whyTitle': 'مصانع سجاد غازي عنتاب — القوة الإنتاجية لتركيا',
  'gaziantepCarpet.whyP1':
    'تُعدّ غازي عنتاب مركزاً إنتاجياً عملاقاً يُشكّل وحده نحو 80% من صادرات السجاد التركية. بأكثر من 500 مصنع سجاد وأكثر من 50,000 موظف وحجم صادرات سنوي يبلغ 3 مليارات دولار، تقع غازي عنتاب في قلب تجارة السجاد العالمية.',
  'gaziantepCarpet.whyP2':
    'تمتلك مصانع سجاد غازي عنتاب منظومة متكاملة من توريد المواد الخام إلى تقنيات الإنتاج، ومن اللوجستيات إلى البنية التحتية للتصدير. تُبقي هذه البنية القوية أسعار السجاد بالجملة تنافسية وتُقصّر مواعيد التسليم.',
  'gaziantepCarpet.whyP3':
    'بعملنا ضمن هذه المنظومة القوية بوصفنا MONS HALI، نقدم للمشترين العالميين أفضل توازن بين السعر والجودة بهويتنا كمصنّع للسجاد بالجملة. نحن شريككم الموثوق في إنتاج السجاد بالجملة في غازي عنتاب.',
  'gaziantepCarpet.whyFact1': 'مصانع سجاد في غازي عنتاب',
  'gaziantepCarpet.whyFact2': 'حصة تصدير السجاد التركي',
  'gaziantepCarpet.whyFact3': 'قيمة التصدير السنوية',
  'gaziantepCarpet.whyRank': 'في تصدير السجاد التركي',

  'gaziantepCarpet.wholesaleLabel': 'مبيعات السجاد بالجملة',
  'gaziantepCarpet.wholesaleTitle': 'تاجر الجملة للسجاد ومزايا أسعار الجملة',
  'gaziantepCarpet.wholesaleSubtitle':
    'نحن المورد الموثوق للمشترين العالميين بأسعارنا المميزة وشروط الدفع المرنة في مبيعات السجاد بالجملة في غازي عنتاب.',
  'gaziantepCarpet.wholesaleP1':
    'تقع أسعار السجاد بالجملة التي نقدمها بوصفنا تاجر جملة عند أكثر المستويات تنافسية في السوق بفضل طاقتنا الإنتاجية العالية ومزايا المواد الخام. تُقدَّم مزايا أسعار الجملة الخاصة للطلبات التي تبلغ 100 م² وأكثر.',
  'gaziantepCarpet.wholesaleP2':
    'تتوفر خيارات دفع مرنة وحدود ائتمانية خاصة واعتماد مستندي لطلبات التصدير لمشتريات السجاد بالجملة في غازي عنتاب. تُقدَّم تسعير خاص وتخطيط إنتاج ذو أولوية للشركاء التجاريين طويلي الأمد.',
  'gaziantepCarpet.wholesaleP3':
    'بوصفنا مصنّعاً للسجاد بالجملة، يمكننا إنتاج سجاد بالجملة بتصاميم وألوان ومقاسات مخصصة لعملائنا المؤسسيين. نقدم حلولاً خاصة للسجاد المطبوع بالشعار ومشاريع الفنادق والطلبات التجارية الكبيرة الحجم.',
  'gaziantepCarpet.wholesaleFeature1': 'مزايا أسعار الجملة من الحد الأدنى للطلب 100 م²',
  'gaziantepCarpet.wholesaleFeature2': 'دفع مرن: خيارات تأجيل 30-60-90 يوماً',
  'gaziantepCarpet.wholesaleFeature3': 'اعتماد مستندي وشحن مؤمَّن لطلبات التصدير',
  'gaziantepCarpet.wholesaleFeature4': 'إنتاج سجاد بتصميم مخصص وشعار',

  'gaziantepCarpet.faqLabel': 'الأسئلة الشائعة',
  'gaziantepCarpet.faqTitle': 'الأسئلة الشائعة',
  'gaziantepCarpet.faq1Q': 'ما هو الحد الأدنى لطلب السجاد بالجملة في غازي عنتاب؟',
  'gaziantepCarpet.faq1A':
    'يتفاوت الحد الأدنى لطلبات السجاد بالجملة في غازي عنتاب حسب نوع المنتج. بالنسبة لطلبات السجاد الآلي، تُقدَّم مزايا أسعار الجملة للطلبات التي تبلغ 100 م² وأكثر. تُطبَّق حدود دنيا منفصلة للسجاد اليدوي والإنتاج المخصص.',
  'gaziantepCarpet.faq2Q': 'إلى أي دول تصدّرون من مصنع السجاد في غازي عنتاب؟',
  'gaziantepCarpet.faq2A':
    'نصدّر السجاد بالجملة من مصنع السجاد لدينا في غازي عنتاب إلى أكثر من 80 دولة تشمل أوروبا والشرق الأوسط وآسيا وأفريقيا. تُعدّ ألمانيا وفرنسا والإمارات والمملكة العربية السعودية والصين واليابان من أبرز أسواق التصدير لدينا.',
  'gaziantepCarpet.faq3Q': 'كيف تُحدَّد أسعار السجاد بالجملة؟',
  'gaziantepCarpet.faq3A':
    'تُحدَّد أسعار السجاد بالجملة بناءً على حجم الطلب ونوع المنتج وتعقيد النمط وشروط التسليم. بفضل مزايا الإنتاج لدينا في غازي عنتاب، يمكننا تقديم أكثر أسعار السجاد بالجملة تنافسية في السوق.',
  'gaziantepCarpet.faq4Q': 'هل تنتجون سجاداً بتصميم مخصص؟',
  'gaziantepCarpet.faq4A':
    'نعم، ننتج سجاداً بالجملة بتصاميم وألوان ومقاسات مخصصة لعملائنا المؤسسيين. تُطبَّق حدود دنيا للطلب على السجاد المطبوع بالشعار ومشاريع الفنادق وتركيبات الأنماط المخصصة.',
  'gaziantepCarpet.faq5Q': 'كيف تعمل اللوجستيات عند تصدير السجاد من غازي عنتاب؟',
  'gaziantepCarpet.faq5A':
    'بفضل الموقع الاستراتيجي لغازي عنتاب والبنية اللوجستية المتطورة، نوصّل طلبات السجاد بالجملة إلى جميع أنحاء العالم براً وبحراً وجواً. تتوفر تغليف خاص وشحن مؤمَّن وخيارات التوصيل من الباب إلى الباب.',

  'gaziantepCarpet.ctaTitle': 'تواصل معنا لطلبات السجاد بالجملة من غازي عنتاب',
  'gaziantepCarpet.ctaDesc':
    'تواصل معنا الآن لمبيعات السجاد بالجملة وتصدير السجاد والإنتاج المخصص من مصنع السجاد لدينا في غازي عنتاب. ضمان السعر التنافسي والتسليم السريع.',

  // Product definitions
  'product.carpet001.name': 'سجادة كلاسيكية فاخرة',
  'product.carpet001.description': 'سجادة كلاسيكية فاخرة بتصميم أنيق ومتانة عالية.',
  'product.carpet002.name': 'سجادة حديثة هندسية',
  'product.carpet002.description': 'سجادة حديثة بأنماط هندسية معاصرة. تضيف لمسة عصرية إلى أي مساحة.',
  'product.carpet003.name': 'سجادة بوهيمية ملونة',
  'product.carpet003.description': 'سجادة بوهيمية نابضة بالحياة بألوان غنية وتصاميم فريدة.',
  'product.carpet004.name': 'سجادة بسيطة محايدة',
  'product.carpet004.description': 'سجادة بسيطة بألوان محايدة تكمل أي نمط ديكور.',
  'product.carpet005.name': 'سجادة عتيقة مستوحاة',
  'product.carpet005.description': 'سجادة عتيقة بتصميم تقليدي وسحر خالد.',
  'product.carpet006.name': 'سجادة طبيعية من الجوت',
  'product.carpet006.description': 'سجادة طبيعية صديقة للبيئة مصنوعة من ألياف الجوت.',
  'product.carpet007.name': 'سجادة فاخرة ناعمة',
  'product.carpet007.description': 'سجادة فاخرة فائقة النعومة بملمس فخم.',
  'product.carpet008.name': 'سجادة للأطفال مرحة',
  'product.carpet008.description': 'سجادة ملونة مرحة مصممة للأطفال. آمنة ومتينة.',
  'product.carpet009.name': 'سجادة إثنية تقليدية',
  'product.carpet009.description': 'سجادة إثنية بأنماط تقليدية وحرفية أصيلة.',
  'product.carpet010.name': 'سجادة معاصرة مجردة',
  'product.carpet010.description': 'سجادة معاصرة بتصميم مجرد فني.',
  'product.carpet011.name': 'سجادة ساحلية مخططة',
  'product.carpet011.description': 'سجادة ساحلية بخطوط منعشة وألوان البحر.',
  'product.carpet012.name': 'سجادة صناعية حضرية',
  'product.carpet012.description': 'سجادة صناعية بمظهر حضري عصري.',
  'product.carpet013.name': 'سجادة ريفية دافئة',
  'product.carpet013.description': 'سجادة ريفية دافئة بسحر ريفي.',
  'product.carpet014.name': 'سجادة فنية معاصرة',
  'product.carpet014.description': 'سجادة فنية بتصميم معاصر فريد.',
  'product.carpet015.name': 'سجادة انتقالية متعددة الاستخدامات',
  'product.carpet015.description': 'سجادة انتقالية تمزج بين الكلاسيكي والحديث.',
  'product.carpet016.name': 'سجادة إسكندنافية بسيطة',
  'product.carpet016.description': 'سجادة إسكندنافية بتصميم بسيط ونظيف.',
  'product.carpet017.name': 'سجادة شرقية فاخرة',
  'product.carpet017.description': 'سجادة شرقية فاخرة بتفاصيل معقدة.',
  'product.carpet018.name': 'سجادة مغربية مزخرفة',
  'product.carpet018.description': 'سجادة مغربية بأنماط زخرفية غنية.',
  'product.carpet019.name': 'سجادة حديثة أحادية اللون',
  'product.carpet019.description': 'سجادة حديثة بلوحة ألوان أحادية.',
  'product.carpet020.name': 'سجادة نباتية طبيعية',
  'product.carpet020.description': 'سجادة نباتية بتصاميم مستوحاة من الطبيعة.',
  'product.carpet021.name': 'سجادة هندسية جريئة',
  'product.carpet021.description': 'سجادة هندسية بأنماط جريئة ومذهلة.',
  'product.carpet022.name': 'سجادة ناعمة فاخرة',
  'product.carpet022.description': 'سجادة ناعمة فائقة الفخامة بملمس سحابي.',
  'product.carpet023.name': 'سجادة عتيقة متعثرة',
  'product.carpet023.description': 'سجادة عتيقة بمظهر متعثر عصري.',
  'product.carpet024.name': 'سجادة استوائية نابضة',
  'product.carpet024.description': 'سجادة استوائية بألوان نابضة وتصاميم غريبة.',
  'product.carpet025.name': 'سجادة صناعية معدنية',
  'product.carpet025.description': 'سجادة صناعية بلمسات معدنية.',
  'product.carpet026.name': 'سجادة ريفية أصيلة',
  'product.carpet026.description': 'سجادة ريفية بسحر ريفي أصيل.',
  'product.carpet027.name': 'سجادة فنية تعبيرية',
  'product.carpet027.description': 'سجادة فنية بتصميم تعبيري جريء.',
  'product.carpet028.name': 'سجادة ساحلية هادئة',
  'product.carpet028.description': 'سجادة ساحلية بألوان هادئة ومريحة.',
  'product.carpet029.name': 'سجادة حديثة متطورة',
  'product.carpet029.description': 'سجادة حديثة بتصميم متطور وأنيق.',
  'product.carpet030.name': 'سجادة تقليدية خالدة',
  'product.carpet030.description': 'سجادة تقليدية بتصميم خالد وكلاسيكي.',

  'product.feature.material': 'المادة',
  'product.feature.production': 'الإنتاج',
  'product.feature.pileHeight': 'ارتفاع الوبر',
  'product.feature.base': 'القاعدة',

  'product.value.polypropylene': 'بولي بروبيلين',
  'product.value.flatWeave': 'نسيج مسطح',
  'product.value.machineWoven': 'منسوج آليًا',
  'product.value.jute': 'جوت',
  'product.value.lowPile': 'وبر منخفض',
  'product.value.mediumPile': 'وبر متوسط',
  'product.value.highPile': 'وبر عالي',

  'product.modal.prevProduct': 'المنتج السابق',
  'product.modal.nextProduct': 'المنتج التالي',
  'product.modal.sizesTitle': 'المقاسات والأبعاد',
  'product.modal.featuresTitle': 'مواصفات المنتج',
  'product.modal.productCode': 'كود المنتج',
  'product.modal.backToPage': 'العودة إلى الصفحة',
  'product.modal.zoomHint': 'انقر على الصورة للتكبير',
  'product.modal.fullscreenHint': 'انقر نقرًا مزدوجًا للتكبير · التمرير للتكبير · السحب للتحريك',
  'product.modal.fullscreen': 'ملء الشاشة',

  // Home Welcome
  'home.welcome.title': 'مرحباً بكم في MONS HALI',
  'home.welcome.description':
    'في MONS HALI، نحن ننتج سجاداً عالي الجودة منذ سنوات. نقدم أفضل المنتجات لعملائنا بفضل منشآت الإنتاج الحديثة وفريق الخبراء لدينا.',
  'home.welcome.learnMore': 'اعرف المزيد',

  // Home Blog Posts
  'blog.home101.title': 'الاستدامة في صناعة النسيج',
  'blog.home101.excerpt': 'معلومات تفصيلية حول عمليات الإنتاج الصديقة للبيئة ونهجنا المستدام في النسيج.',
  'blog.home101.date': '15 مارس 2024',
  'blog.home101.readTime': '5 دقائق',
  'blog.home102.title': 'اتجاهات النسيج لعام 2024',
  'blog.home102.excerpt': 'آراء الخبراء وتوقعاتهم حول اتجاهات النسيج للموسم الجديد ولوحات الألوان.',
  'blog.home102.date': '10 مارس 2024',
  'blog.home102.readTime': '7 دقائق',
  'blog.home103.title': 'عمليات مراقبة الجودة لدينا',
  'blog.home103.excerpt': 'عمليات المراقبة الدقيقة التي نطبقها لضمان استيفاء منتجاتنا لأعلى معايير الجودة.',
  'blog.home103.date': '5 مارس 2024',
  'blog.home103.readTime': '6 دقائق',

  // Collections Hero Slider
  'collectionsHero.slide1.tag': 'بيع السجاد بالجملة',
  'collectionsHero.slide1.title': 'مجموعات سجاد\nفاخرة',
  'collectionsHero.slide1.subtitle': 'إنتاج السجاد بالجملة من غازي عنتاب إلى العالم، تصدير إلى أكثر من 50 دولة',
  'collectionsHero.slide1.stat1Label': 'دول التصدير',
  'collectionsHero.slide1.stat2Label': 'سنوات من الخبرة',
  'collectionsHero.slide2.tag': 'إنتاج السجاد بالجملة',
  'collectionsHero.slide2.title': 'مركز بيع\nالسجاد بالجملة',
  'collectionsHero.slide2.subtitle': 'إنتاج آلاف الأمتار المربعة من السجاد يومياً في منشآتنا المعتمدة بـ ISO 9001',
  'collectionsHero.slide2.stat1Label': 'مجموعات خاصة',
  'collectionsHero.slide2.stat2Label': 'وكيل نشط',
  'collectionsHero.slide3.tag': 'تصدير السجاد',
  'collectionsHero.slide3.title': 'مصنع سجاد\nمفتوح على العالم',
  'collectionsHero.slide3.subtitle': 'أضف قيمة لمساحاتك المعيشية بالتصاميم الحديثة والحرفية التقليدية',
  'collectionsHero.slide3.stat1Label': 'م² إنتاج سنوي',
  'collectionsHero.slide3.stat2Label': 'نمط فريد',
  'collectionsHero.cta.explore': 'استكشف المجموعات',
  'collectionsHero.cta.price': 'احصل على سعر الجملة',
  'collectionsHero.aria.slider': 'سلايدر مجموعات السجاد بالجملة',
  'collectionsHero.aria.slide': 'شريحة',
  'collectionsHero.aria.prev': 'الشريحة السابقة',
  'collectionsHero.aria.next': 'الشريحة التالية',
  'collectionsHero.aria.goto': 'انتقل إلى المجموعات',

  // Contact Page (flat keys)
  'contact.title': 'اتصل بنا',
  'contact.subtitle': 'تواصل معنا',
  'contact.heroSubtitle': 'تواصل معنا، يسعدنا مساعدتك',
  'contact.info': 'معلومات الاتصال',
  'contact.address': 'العنوان',
  'contact.addressValue': 'المنطقة الصناعية المنظمة، الشارع الخامس رقم: 42، غازي عنتاب، تركيا',
  'contact.phone': 'الهاتف',
  'contact.email': 'البريد الإلكتروني',
  'contact.workingHours': 'ساعات العمل',
  'contact.workingHoursValue': 'الاثنين - الجمعة: 08:00 - 18:00',
  'contact.visitUs': 'زورونا',
  'contact.visitUsDesc': 'يمكنك تحديد موعد لزيارة مصنعنا وصالة العرض.',
  'contact.mapTitle': 'خريطة الموقع',
  'contact.form.title': 'أرسل لنا رسالة',
  'contact.form.reachUs': 'تواصل معنا',
  'contact.form.reachUsDesc': 'املأ النموذج لأسئلتك أو اقتراحاتك أو مقترحات التعاون، وسنرد عليك في أقرب وقت ممكن.',
  'contact.form.name': 'الاسم الكامل',
  'contact.form.namePlaceholder': 'اسمك الأول والأخير',
  'contact.form.email': 'البريد الإلكتروني',
  'contact.form.emailPlaceholder': 'example@email.com',
  'contact.form.phone': 'الهاتف',
  'contact.form.phonePlaceholder': '+90 5XX XXX XX XX',
  'contact.form.subject': 'الموضوع',
  'contact.form.subjectPlaceholder': 'اختر موضوعاً',
  'contact.form.subject.general': 'معلومات عامة',
  'contact.form.subject.product': 'معلومات المنتج',
  'contact.form.subject.dealer': 'الوكالة',
  'contact.form.subject.sales': 'المبيعات',
  'contact.form.subject.support': 'الدعم الفني',
  'contact.form.message': 'رسالتك',
  'contact.form.messagePlaceholder': 'اكتب رسالتك هنا... (الحد الأقصى 500 حرف)',
  'contact.form.send': 'إرسال',
  'contact.form.success': 'تم إرسال رسالتك بنجاح.',

  // Collections Hero Slider
  'collectionsHero.slide1.tag': 'بيع السجاد بالجملة',
  'collectionsHero.slide1.title': 'مجموعات سجاد\nفاخرة',
  'collectionsHero.slide1.subtitle': 'إنتاج السجاد بالجملة من غازي عنتاب إلى العالم، تصدير إلى أكثر من 50 دولة',
  'collectionsHero.slide1.stat1Label': 'دول التصدير',
  'collectionsHero.slide1.stat2Label': 'سنوات من الخبرة',
  'collectionsHero.slide2.tag': 'إنتاج السجاد بالجملة',
  'collectionsHero.slide2.title': 'مركز بيع\nالسجاد بالجملة',
  'collectionsHero.slide2.subtitle': 'إنتاج آلاف الأمتار المربعة من السجاد يومياً في منشآتنا المعتمدة بـ ISO 9001',
  'collectionsHero.slide2.stat1Label': 'مجموعات خاصة',
  'collectionsHero.slide2.stat2Label': 'وكيل نشط',
  'collectionsHero.slide3.tag': 'تصدير السجاد',
  'collectionsHero.slide3.title': 'مصنع سجاد\nمفتوح على العالم',
  'collectionsHero.slide3.subtitle': 'أضف قيمة لمساحاتك المعيشية بالتصاميم الحديثة والحرفية التقليدية',
  'collectionsHero.slide3.stat1Label': 'م² إنتاج سنوي',
  'collectionsHero.slide3.stat2Label': 'نمط فريد',
  'collectionsHero.cta.explore': 'استكشف المجموعات',
  'collectionsHero.cta.price': 'احصل على سعر الجملة',
  'collectionsHero.aria.slider': 'سلايدر مجموعات السجاد بالجملة',
  'collectionsHero.aria.slide': 'شريحة',
  'collectionsHero.aria.prev': 'الشريحة السابقة',
  'collectionsHero.aria.next': 'الشريحة التالية',
  'collectionsHero.aria.goto': 'انتقل إلى المجموعات',

  // Contact Page
  'contact.title': 'اتصل بنا',
  'contact.subtitle': 'تواصل معنا',
  'contact.heroSubtitle': 'تواصل معنا، يسعدنا مساعدتك',
  'contact.info': 'معلومات الاتصال',
  'contact.address': 'العنوان',
  'contact.addressValue': 'المنطقة الصناعية المنظمة، الشارع الخامس رقم: 42، غازي عنتاب، تركيا',
  'contact.phone': 'الهاتف',
  'contact.email': 'البريد الإلكتروني',
  'contact.workingHours': 'ساعات العمل',
  'contact.workingHoursValue': 'الاثنين - الجمعة: 08:00 - 18:00',
  'contact.visitUs': 'زورونا',
  'contact.visitUsDesc': 'يمكنك تحديد موعد لزيارة مصنعنا وصالة العرض.',
  'contact.mapTitle': 'خريطة الموقع',
  'contact.form.title': 'أرسل لنا رسالة',
  'contact.form.reachUs': 'تواصل معنا',
  'contact.form.reachUsDesc': 'املأ النموذج لأسئلتك أو اقتراحاتك أو مقترحات التعاون، وسنرد عليك في أقرب وقت ممكن.',
  'contact.form.name': 'الاسم الكامل',
  'contact.form.namePlaceholder': 'اسمك الأول والأخير',
  'contact.form.email': 'البريد الإلكتروني',
  'contact.form.emailPlaceholder': 'example@email.com',
  'contact.form.phone': 'الهاتف',
  'contact.form.phonePlaceholder': '+90 5XX XXX XX XX',
  'contact.form.subject': 'الموضوع',
  'contact.form.subjectPlaceholder': 'اختر موضوعاً',
  'contact.form.subject.general': 'معلومات عامة',
  'contact.form.subject.product': 'معلومات المنتج',
  'contact.form.subject.dealer': 'الوكالة',
  'contact.form.subject.sales': 'المبيعات',
  'contact.form.subject.support': 'الدعم الفني',
  'contact.form.message': 'رسالتك',
  'contact.form.messagePlaceholder': 'اكتب رسالتك هنا... (الحد الأقصى 500 حرف)',
  'contact.form.send': 'إرسال',
  'contact.form.success': 'تم إرسال رسالتك بنجاح.',

  // Quick Menu
  quickMenu: {
    title: 'القائمة السريعة',
    subtitle: 'MONS HALI سجاد',
    language: 'اللغة',
    collections: 'المجموعات',
    dealerLogin: 'تسجيل دخول الوكيل',
    dealerLoginDesc: 'الوصول إلى لوحة الوكيل',
    contact: 'اتصل بنا',
    kvkk: 'KVKK والمستندات',
    whatsapp: 'واتساب',
    whatsappDesc: 'إرسال رسالة',
    call: 'اتصل',
    callDesc: 'اتصل الآن',
  },

  // Vision Mission Page
  visionMission: {
    heroTitle: 'الرؤية والرسالة',
    heroSubtitle: 'أهدافنا وقيمنا للمستقبل',
    heroAlt: 'الرؤية والرسالة',
    ourVision: 'رؤيتنا',
    visionImgAlt: 'الرؤية',
    visionP1: 'أن نصبح علامة تجارية رائدة في مجالات الجودة والابتكار والاستدامة في صناعة السجاد العالمية. دمج فن السجاد التركي مع تقنيات الإنتاج الحديثة والوصول إلى مكانة أكثر مصنّعي السجاد الفاخر تفضيلاً في السوق العالمية.',
    visionP2: 'بحلول عام 2030، نهدف إلى التواجد في أكثر من 100 دولة، والوصول إلى طاقة إنتاجية سنوية تبلغ 2 مليون م²، وأن نكون رواداً في الإنتاج المستدام في الصناعة.',
    ourMission: 'رسالتنا',
    missionImgAlt: 'الرسالة',
    missionP1: 'إنتاج سجاد فاخر بمعايير عالمية من خلال الجمع بين أحدث التقنيات والحرف اليدوية التقليدية. إضافة قيمة لمساحات المعيشة من خلال تقديم منتجات تجمع بين الجماليات والراحة والمتانة لعملائنا.',
    missionP2: 'أن نكون قدوة للصناعة من خلال عمليات الإنتاج الصديقة للبيئة وممارسات الأعمال الأخلاقية ومبادئ العمل المتمحورة حول التحسين المستمر، وخلق قيمة لجميع أصحاب المصلحة لدينا.',
    ourValues: 'قيمنا',
    valuesSubtitle: 'قيمنا الأساسية التي تشكّل مبادئ عملنا وتقودنا نحو النجاح',
    value1Title: 'الجودة',
    value1Desc: 'نقدم منتجات ممتازة لعملائنا من خلال الحفاظ على أعلى معايير الجودة في كل مرحلة من مراحل الإنتاج.',
    value2Title: 'الاستدامة',
    value2Desc: 'نستثمر بمسؤولية في المستقبل من خلال عمليات الإنتاج الصديقة للبيئة واستخدام الطاقة المتجددة.',
    value3Title: 'الابتكار',
    value3Desc: 'نطور منتجات وتقنيات إنتاج مبتكرة تقود الصناعة من خلال أنشطة البحث والتطوير لدينا.',
    value4Title: 'التركيز على الإنسان',
    value4Desc: 'نخلق بيئة عمل سعيدة ومنتجة من خلال الاستثمار في تطوير موظفينا.',
    value5Title: 'رضا العملاء',
    value5Desc: 'نبني شراكات تجارية طويلة الأمد بنهج خدمة يتجاوز توقعات عملائنا.',
    value6Title: 'الرؤية العالمية',
    value6Desc: 'نجعل بلدنا فخوراً بتمثيل صناعة السجاد التركية بأفضل طريقة في الأسواق العالمية.',
  },
};

// Vision Mission Page
export const visionMission = {
  heroTitle: 'الرؤية والرسالة',
  heroSubtitle: 'أهدافنا وقيمنا للمستقبل',
  heroAlt: 'الرؤية والرسالة',
  ourVision: 'رؤيتنا',
  visionImgAlt: 'الرؤية',
  visionP1: 'أن نصبح علامة تجارية رائدة في مجالات الجودة والابتكار والاستدامة في صناعة السجاد العالمية. دمج فن السجاد التركي مع تقنيات الإنتاج الحديثة والوصول إلى مكانة أكثر مصنّعي السجاد الفاخر تفضيلاً في السوق العالمية.',
  visionP2: 'بحلول عام 2030، نهدف إلى التواجد في أكثر من 100 دولة، والوصول إلى طاقة إنتاجية سنوية تبلغ 2 مليون م²، وأن نكون رواداً في الإنتاج المستدام في الصناعة.',
  ourMission: 'رسالتنا',
  missionImgAlt: 'الرسالة',
  missionP1: 'إنتاج سجاد فاخر بمعايير عالمية من خلال الجمع بين أحدث التقنيات والحرف اليدوية التقليدية. إضافة قيمة لمساحات المعيشة من خلال تقديم منتجات تجمع بين الجماليات والراحة والمتانة لعملائنا.',
  missionP2: 'أن نكون قدوة للصناعة من خلال عمليات الإنتاج الصديقة للبيئة وممارسات الأعمال الأخلاقية ومبادئ العمل المتمحورة حول التحسين المستمر، وخلق قيمة لجميع أصحاب المصلحة لدينا.',
  ourValues: 'قيمنا',
  valuesSubtitle: 'قيمنا الأساسية التي تشكّل مبادئ عملنا وتقودنا نحو النجاح',
  value1Title: 'الجودة',
  value1Desc: 'نقدم منتجات ممتازة لعملائنا من خلال الحفاظ على أعلى معايير الجودة في كل مرحلة من مراحل الإنتاج.',
  value2Title: 'الاستدامة',
  value2Desc: 'نستثمر بمسؤولية في المستقبل من خلال عمليات الإنتاج الصديقة للبيئة واستخدام الطاقة المتجددة.',
  value3Title: 'الابتكار',
  value3Desc: 'نطور منتجات وتقنيات إنتاج مبتكرة تقود الصناعة من خلال أنشطة البحث والتطوير لدينا.',
  value4Title: 'التركيز على الإنسان',
  value4Desc: 'نخلق بيئة عمل سعيدة ومنتجة من خلال الاستثمار في تطوير موظفينا.',
  value5Title: 'رضا العملاء',
  value5Desc: 'نبني شراكات تجارية طويلة الأمد بنهج خدمة يتجاوز توقعات عملائنا.',
  value6Title: 'الرؤية العالمية',
  value6Desc: 'نجعل بلدنا فخوراً بتمثيل صناعة السجاد التركية بأفضل طريقة في الأسواق العالمية.',
};
